import React from 'react'
import { RangeFragment } from '../../src/model/fragments'
import { useSetFilterPreview } from '../Filter'
import { useSetfilterIsUseful } from '../Filters'
import { IntervalSlider, IntervalSliderProps } from '../IntervalSlider'

interface RangeProps {
	onChange: (range: RangeFragment | null) => void,
	selected: RangeFragment | null,
	range: RangeFragment,
	sliderProps: Pick<IntervalSliderProps, 'currency' | 'suffix'>
}

export const Range: React.FC<RangeProps> = ({
	onChange,
	selected,
	range,
	sliderProps,
}) => {
	if(!range || range.min === range.max)
	{
		return <></>
	}

	const setFilterPreview = useSetFilterPreview()
	const setIsUseful = useSetfilterIsUseful()

	const currentMin = React.useMemo(() => Math.max(range.min || 0, selected?.min || range.min || 0), [range, selected]);
	const currentMax = React.useMemo(() => Math.min(range.max || 0, selected?.max || range.max || 0), [range, selected]);

	React.useEffect(() => {
		const isAdjusted = range.min !== currentMin || range.max !== currentMax
		setFilterPreview(isAdjusted ? 'Upravit' : null)
	}, [setFilterPreview, range, currentMin, currentMax])

	React.useEffect(() => {
		setIsUseful(range.min !== range.max)
	}, [setIsUseful, range])

	return (
		<IntervalSlider
			min={range.min}
			max={range.max}
			currentMin={currentMin}
			currentMax={currentMax}
			onChange={(min, max) => onChange((min != range.min || max != range.max) ? { min, max } : null)}
			{...sliderProps}
		/>
	)
}